// extracted by mini-css-extract-plugin
export var statItem = "_lk-1";
export var statsRow = "_lk-0";